module.exports = __webpack_public_path__ + "img/CRT_Sword-005.a7729f2f.png";